<div class="twc-card" [ngClass]="{'twc-loader-container': isLoading}">
    <header class="twc-card-header">
        <h4 class="twc-card-title" (click)="navigateToReports()">{{'NAVBAR.REPORTS' | translate}}</h4>
    </header>
    <div class="twc-card-content">
        <div class="twc-message-box twc-message-box-warning" *ngIf="showWarningMsg">
            {{'REPORTS.WARNING_LOW_CREDITS' | translate}}
        </div>

        <div *ngIf="msgError" class="twc-message-box twc-message-box-error twc-mt-3 twc-mb-3">
            <p translate> {{ msgError | translate }} </p>
        </div>

        <div class="twc-d-flex align-center reports-container">
            <div class="twc-mb-4 twc-mr-3">
                <cw-report *ngIf="companyReportData" [title]="companyReportName"
                    [reportData]="companyReportData"></cw-report>
            </div>
            <div class="twc-mb-4 twc-mr-3">
                <cw-report *ngIf="userReportData" [title]="userReportName" [reportData]="userReportData"
                    class="twc-mb-3"></cw-report>
            </div>
        </div>
    </div>
    <div class="twc-loader-overlay" *ngIf="isLoading">
        <twc-loader size="large"></twc-loader>
    </div>
</div>